"use client";

import { I18nUtil } from "@utils/i18n";
import type { DailyMarketLanguage } from "@/src/components/DailyMarketSummary/types";

/**
 * Daily Market API `language`：与全仓一致，走 `I18nUtil.getBackgroundLanguageKey`
 *（前端 `en` / `zh-tw` → 后端 `en-US` / `zh-TW`）。
 */
export const useDailyMarketLanguage = (): DailyMarketLanguage =>
  I18nUtil.getBackgroundLanguageKey(
    I18nUtil.getCurrentLocale(),
  ) as DailyMarketLanguage;
